import {Component, OnInit, SecurityContext} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {Router} from '@angular/router';
import {DataService, DatasetBannerModel} from 'src/app/services/data.service';
import {TrustiiService} from 'src/app/services/trustii.service';
import {tap, catchError} from 'rxjs/operators';
import {throwError} from 'rxjs';

@Component({
  selector: 'app-enterprise-banner',
  templateUrl: './enterprise-banner.component.html',
  styleUrls: ['./enterprise-banner.component.scss']
})
export class EnterpriseBannerComponent implements OnInit {

  backgroundImage = '';
  isDatasetView = false;
  isForumView = false;
  isLeaderboardView = false;
  isRulesView = false;
  isPrizeView = false;
  imagePrefix = 'data:image/png;base64,';
  dataset: any;

  constructor(public domSanitizer: DomSanitizer, public dataservice: DataService, private router: Router,
              public datasetBannerModel: DatasetBannerModel, private trustiiService: TrustiiService) {
  }

  ngOnInit() {
    this.getDataset();
    this.datasetBannerModel.datasetBannerUpdate.subscribe(() => {
      this.isDatasetView = this.datasetBannerModel.isDatasetView;
      this.isForumView = this.datasetBannerModel.isForumView;
      this.isLeaderboardView = this.datasetBannerModel.isLeaderboardView;
      this.isRulesView = this.datasetBannerModel.isRulesView;
      this.isPrizeView = this.datasetBannerModel.isPrizeView;
    });
    const img = this.datasetBannerModel.dataset.image !== null ?
      this.datasetBannerModel.dataset.image :
      this.dataservice.defaultDatasetIcon;
    this.backgroundImage = this.domSanitizer.sanitize(SecurityContext.RESOURCE_URL,
      this.domSanitizer.bypassSecurityTrustResourceUrl(this.imagePrefix + img));

  }

  getDataset() {
    this.trustiiService.getDataset(this.datasetBannerModel.dataset.id)
      .pipe(
        tap((dataset: any) => this.dataset = dataset.data),
        tap((dataset: any) => Object.assign(this.datasetBannerModel.dataset, dataset.data)),
        tap((dataset: any) => this.dataservice.data = dataset.data),
        catchError((error) => {
          return throwError(error);
        })
      ).subscribe();
  }

  loadDatasetView() {
    this.router.navigateByUrl('datasets/' + this.datasetBannerModel.dataset.id);
  }

  loadForumView() {
    this.router.navigateByUrl('datasets/' + this.datasetBannerModel.dataset.id + '/forums');
  }

  loadRulesView() {
    this.router.navigateByUrl('datasets/' + this.datasetBannerModel.dataset.id + '/rules');
  }

  loadLeaderBoardV2View() {
    this.router.navigateByUrl('leaderboard-v2/' + this.datasetBannerModel.dataset.id);
  }

  loadPrizeView() {
    this.router.navigateByUrl('datasets/' + this.datasetBannerModel.dataset.id + '/prize');
  }

  redirectToResult(url) {
    window.open(url);
  }
  backToDataset() {
    this.router.navigateByUrl('enterprises/datasets');
  }
}
